import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "mexicanPhone",
})
export class MexicanPhonePipe implements PipeTransform {
  transform(value: string | number): string {
    if (!value) {
      return "";
    }

    // Convert to string and remove any non-digit characters
    const cleaned = String(value).replace(/\D/g, "");

    // Check if it's a valid Mexican phone number (10 digits)
    if (cleaned.length !== 10) {
      return String(value); // Return original if not valid
    }

    // Format as +52 XX XXXX XXXX
    const area_code = cleaned.substring(0, 2);
    const first_part = cleaned.substring(2, 6);
    const second_part = cleaned.substring(6, 10);

    return `+52 ${area_code} ${first_part} ${second_part}`;
  }
}
